// extracted by mini-css-extract-plugin
export default {"columnTitle":"EditEventProperties_columnTitle__N1FgV","backLink":"EditEventProperties_backLink__2KMbY"};